class images {
  constructor() {
    if (!images.instance) {
      images.instance = this;
    }
    return images.instance;
  }

  logo = require("./images/logo.png");
  branch = require("./images/SPHACY.png");
  flashsale = require("./images/flash-sale.png");
  flashsalebanner = require("./images/flashsalebanner.png");
  item1 = require("./images/item1.png");
  item2 = require("./images/item2.png");
  item3 = require("./images/item3.png");
  category1 = require("./images/category1.png");
  category2 = require("./images/category2.png");
  category3 = require("./images/category3.png");
  categorybanner1 = require("./images/categorybanner1.png");
  categorybanner2 = require("./images/categorybanner2.png");
  categorybanner3 = require("./images/categorybanner3.png");
  categorydetails = require("./images/categorydetails.png");
  service1 = require("./images/service1.png");
  start = require("./images/start.png");
  download = require("./images/download.png");
  googleplay = require("./images/googleplay.png");
  appstore = require("./images/appstore.png");
  imgproductitem = require("./images/products/img-products-defaut.png");
  imgproductitem1 = require("./images/products/img-products-defaut-3.png");
  imgproductitem2 = require("./images/products/img-products-defaut-4.png");
  imgproductitem3 = require("./images/products/img-products-defaut-1.png");
  bannerdefaut = require("./images/banner-defaut.png");
  agency1 = require("./images/agency1.png");
  agency2 = require("./images/Agency2.png");
  agency3 = require("./images/agency3.png");
  agency4 = require("./images/agency4.png");
  agency5 = require("./images/agency5.png");
  signin = require("./images/singin.png");
  bgsignin = require("./images/bgsingin.png");
  logofb = require("./images/logofb.png");
  comingsoon = require("./images/comingsoon.png");
  cod = require("./images/cod.png");
  atm = require("./images/atm.png");
  visa = require("./images/visa.png");
  productbill = require("./images/productbill.png");
  Sphacy = require("./images/SPHACY.png");
  support = require("./images/support.png");
  logoPNG = require("./images/logoPNG.png");
  newsignup = require("./images/newsignup.png");
  covn = require("./images/covn.png");
  zaloicon = require("./images/zaloicon.png");
  bannersignup = require("./images/bannersignup.png");
}

const instance = new images();
export default instance;
